<div id="buildingInfoUpdate-main-wraper">
  <div class="col-12 search-ft p-0 mt-3">
    <div class="row">
      <div class="col-4">
        <div class="form-group">
          <label name="lblBuildingInfo" class="control-label">Unit Number / Building Name / Building Id</label>
          <input type="text" class="form-control" name="txtSrch" maxlength="64" [(ngModel)]="txtBuildingSrch"
            tabindex="1" (keydown.enter)="onKeyEnter()"/>
        </div>
      </div> 
        <div class="col d-flex align-items">      
          <div class="form-group">
            <mat-radio-group [(ngModel)]="rbSelectedOption" (change)="rbChange()">
              <mat-radio-button value="1" >Building Info</mat-radio-button>
              <mat-radio-button value="2" checked="true">CPIB Device Type</mat-radio-button>
            </mat-radio-group>
            <button class="btn btn-primary mr-2 alignbuttonleft" name="btnUnitSrch" tabindex="3" (click)="getUnitBuildingNameSearch()">
              Search
            </button>
            <button class="btn btn-outline-primary mr-2" name="btnSearchReset" tabindex="4" (click)="onResetFilters()">
              Reset
            </button>
          </div>          
        </div>
        <div class="d-flex align-items alignbutton" >
            <button class="btn btn-provision-style" [disabled]="!enableCheckAll" name="btnSave" tabindex="4" (click)="open(UnitInfoModal)">
              <em class="fas fa-save"></em> Save
            </button>
        </div>
      </div>    
  </div>
  <div class="bgcolor">
    <div class="alignment" *ngIf="enableBuildingDet">
      <input type="checkbox" class="chkAlign" [disabled]="!enableCheckAll" (change)="enableDisableSave($event)" [checked]="isCheckAll"><label class="lblInfo ml-2 lblalign">Select All</label>
    </div>
    <ag-grid-angular #agGridUnitSync [enableCellTextSelection]="true" class="ag-theme-material gateway-layout" [rowData]="rowData"
      [columnDefs]="columnDefs" [gridOptions]="gridOptions" tabindex="6"
      (cellValueChanged)="onCellValueChanged($event)" 
      (gridReady)="onGridReady($event)"
      >
    </ag-grid-angular>
  </div>
</div>

<ng-template #UnitInfoModal let-modal>  
  <div id="syncUnit" class="eloUpdateStyle">
    <div class="modal-body">
      <div class="col-12 search-ft p-2 pt-1">
      <div class="modal-header popup-modal-header">
        <h5 class="modal-title popup-modal-title" *ngIf="isCheckAll">New Building Details</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.close()">
          <em class="fa fa-window-close"></em>
        </button>
      </div>
      <div class="row" *ngIf="enableBuildingDet && !isCheckAll">
        <div class="col">
          <div class="form-group">
            &nbsp;<label class="lblInfo prelinetext">Below units are going to be updated with new <b>Building Info</b>, Click 'Update' to proceed<br><br><span [innerHTML]="gatewayTypesInfo"></span></label> 
          </div>
        </div>
      </div>
      <div class="row" *ngIf="enableCPIBDeviceCol">
        <div class="col">
          <div class="form-group prelinetext">
            <label class="lblInfo prelinetext">Below units are going to be updated with new <b>CPIB Device Type</b>, Click 'Update' to proceed <br><br><span [innerHTML]="gatewayTypesInfo"></span></label>             
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isCheckAll">
        <div class="col">
          <div class="row bulk-update-row">
            <div class="col-12">
              <div class="form-group bulk-update-field">
                <label class="lblInfo alignLabel bulk-update-label">Building Id</label>
                <input type="text" class="form-control bulk-update-input" name="txtBuildingId" [(ngModel)]="txtBuildingId" [attr.maxlength]="buildingFieldMaxLength.buildingId"
                tabindex="1" (focus)="clearErrorMessages()"/>
              </div>
            </div>
          </div>
          <div class="row bulk-update-row">
            <div class="col-12">
              <div class="form-group bulk-update-field">
                <label class="lblInfo alignLabel bulk-update-label">Building Name</label>
                <input type="text" class="form-control bulk-update-input" name="txtBuildingName" [(ngModel)]="txtBuildingName" [attr.maxlength]="buildingFieldMaxLength.buildingName"
                tabindex="1" (focus)="clearErrorMessages()"/>
              </div>
            </div>
          </div>
          <div class="row bulk-update-row">
            <div class="col-12">
              <div class="form-group bulk-update-field">
                <label class="lblInfo alignLabel bulk-update-label">Address</label>
                <input type="text" class="form-control bulk-update-input" name="txtAddress1" [(ngModel)]="txtAddress1" [attr.maxlength]="buildingFieldMaxLength.address1"
                tabindex="1" (focus)="clearErrorMessages()"/>
              </div>
            </div>
          </div>
          <div class="row bulk-update-row">
            <div class="col-12">
              <div class="form-group bulk-update-field">
                <label class="lblInfo alignLabel bulk-update-label">City</label>
                <input type="text" class="form-control bulk-update-input" name="txtCity" [(ngModel)]="txtCity" [attr.maxlength]="buildingFieldMaxLength.city"
                tabindex="1" (focus)="clearErrorMessages()"/>
              </div>
            </div>
          </div>
          <div class="row bulk-update-row">
            <div class="col-12">
              <div class="form-group bulk-update-field">
                <label class="lblInfo alignLabel bulk-update-label">State</label>
                <input type="text" class="form-control bulk-update-input" name="txtState" [(ngModel)]="txtState" [attr.maxlength]="buildingFieldMaxLength.state"
                tabindex="1" (focus)="clearErrorMessages()"/>
              </div>
            </div>
          </div>
          <div class="row bulk-update-row">
            <div class="col-12">
              <div class="form-group bulk-update-field">
                <label class="lblInfo alignLabel bulk-update-label">Postal Code</label>
                <input type="text" class="form-control bulk-update-input" name="txtPostalCode" [(ngModel)]="txtPostalCode" [attr.maxlength]="buildingFieldMaxLength.postalCode"
                tabindex="1" (focus)="clearErrorMessages()"/>
              </div>
            </div>
          </div>
          <div class="lblerror" *ngIf="lblErrorBuildingId">
              {{ this.lblErrorBuildingId }}
            </div>
        </div>
      </div>
      </div>
    </div>
    <div class="modal-footer building-update-footer">
      <label class="building-update-footer-note mb-0">Kindly update the Building Information or CPIB Device Type information manually in the DRM and ELO systems for the respective units</label>
      <div class="building-update-footer-actions">
        <button type="button" class="btn btn-primary mr-2 btnwidth" (click)="onUpdateUnitInfo()">Update</button>
        <button type="button" id="btnClose" class="btn btn-outline-primary btnwidth" (click)="modal.close()">Close</button>
      </div>
    </div>
  </div>  
</ng-template>